import { Container, Typography, Box } from "@mui/material";
import { useLang } from "../context/LanguageContext";

export default function PolitykaPrywatnosci() {
  const { t } = useLang();

  return (
    <Box sx={{ backgroundColor: "#1a1a1a", minHeight: "100vh" }}>
      <Box sx={{ height: 64 }} />
      <Box
        sx={{
          py: 10,
          background: "linear-gradient(135deg, #1c1c1c 0%, #222 100%)",
          color: "#f0f0f0",
          textAlign: "center",
        }}
      >
        <Container>
          <Typography variant="h3" sx={{ fontWeight: 700 }}>
            {t("privacy.title")}
          </Typography>
        </Container>
      </Box>
      <Container sx={{ py: 8, color: "#f0f0f0", maxWidth: "md" }}>
        <Typography variant="body1" sx={{ lineHeight: 1.8, opacity: 0.9 }}>
          {t("privacy.intro")}
        </Typography>

        <Typography variant="h6" sx={{ mt: 4, color: "#1976d2" }}>
          {t("privacy.s1title")}
        </Typography>
        <Typography variant="body1" sx={{ lineHeight: 1.8, opacity: 0.9 }}>
          {t("privacy.s1body")}
        </Typography>

        <Typography variant="h6" sx={{ mt: 4, color: "#1976d2" }}>
          {t("privacy.s2title")}
        </Typography>
        <Typography variant="body1" sx={{ lineHeight: 1.8, opacity: 0.9 }}>
          {t("privacy.s2body1")}
        </Typography>
        <Typography variant="body1" sx={{ lineHeight: 1.8, opacity: 0.9, mt: 2 }}>
          {t("privacy.s2body2")}
        </Typography>

        <Typography variant="h6" sx={{ mt: 4, color: "#1976d2" }}>
          {t("privacy.s3title")}
        </Typography>
        <Typography variant="body1" sx={{ lineHeight: 1.8, opacity: 0.9 }}>
          {t("privacy.s3body")}
        </Typography>

        <Typography variant="h6" sx={{ mt: 4, color: "#1976d2" }}>
          {t("privacy.s4title")}
        </Typography>
        <Typography variant="body1" sx={{ lineHeight: 1.8, opacity: 0.9 }}>
          {t("privacy.s4body")}
        </Typography>

        <Typography variant="h6" sx={{ mt: 4, color: "#1976d2" }}>
          {t("privacy.s5title")}
        </Typography>
        <Typography variant="body1" sx={{ lineHeight: 1.8, opacity: 0.9 }}>
          {t("privacy.s5body")}
        </Typography>

        <Typography variant="h6" sx={{ mt: 4, color: "#1976d2" }}>
          {t("privacy.s6title")}
        </Typography>
        <Typography variant="body1" sx={{ lineHeight: 1.8, opacity: 0.9 }}>
          {t("privacy.s6body")}
        </Typography>

        <Typography variant="body1" sx={{ mt: 4, lineHeight: 1.8, opacity: 0.6, fontStyle: "italic" }}>
          {t("privacy.updated")}
        </Typography>
      </Container>
    </Box>
  );
}
